import { getAuthAxiosBackend } from "@/helpers/axios"

class AdmissionChannelsServices {
    get(id) {
        return getAuthAxiosBackend().get('AdmissionChannels/getAdmissionChannelById/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('AdmissionChannels/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('AdmissionChannels/addedAdmissionChannel', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('AdmissionChannels/updateAdmissionChannel/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('AdmissionChannels/restoreAdmissionChannel/' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('AdmissionChannels/softDeleteAdmissionChannel/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('AdmissionChannels/deleteAdmissionChannel/' + id.toString())
    }
}

export default new AdmissionChannelsServices()
